export const mempoolMethods = {
    getBalance: async (client, baseUrl, { address }) => {
        const apiUrl = `${baseUrl}/address/${address}`;
        const response = (await client.request({
            url: apiUrl,
            fetchOptions: { method: 'GET' },
        }));
        const balance = response.chain_stats.funded_txo_sum - response.chain_stats.spent_txo_sum;
        return {
            result: BigInt(balance),
        };
    },
};
//# sourceMappingURL=mempool.js.map